import { render, staticRenderFns } from "./RolePermissions.vue?vue&type=template&id=420b9550"
import script from "./RolePermissions.vue?vue&type=script&lang=js"
export * from "./RolePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports